export const DEBUG = process.env.NODE_ENV !== 'production';

export function getLomaUrlClient(): string {
  return (
    process.env.NEXT_PUBLIC_LOMA_URL_CLIENT ||
    process.env.LOMA_URL_CLIENT ||
    'https://loma-cdn.domain-cpmt-platform.qa20.narvar.qa/graphql'
  );
}

export function getReturnsGraphqlUrl(): string {
  return (
    process.env.NEXT_PUBLIC_RETURNS_GRAPHQL_URL ||
    process.env.RETURNS_GRAPHQL_URL ||
    'https://returns-apis-graphql-qa01.narvar.qa/graphql'
  );
}

export function getReturnServicesUrl(): string {
  return (
    process.env.NEXT_PUBLIC_RETURN_SERVICES_URL ||
    process.env.RETURN_SERVICES_URL ||
    'https://returns-qa01.narvar.qa'
  );
}

export function getNoflakeUrl(): string {
  return (
    process.env.NEXT_PUBLIC_NOFLAKE_URL ||
    process.env.NOFLAKE_URL ||
    'https://titanlite-235686439465.us-central1.run.app/v2/noflake'
  );
}

export function getAppsGatewayUrl(): string {
  return (
    process.env.NEXT_PUBLIC_APPS_GATEWAY_URL ||
    process.env.APPS_GATEWAY_URL ||
    'https://apps.qa20.narvar.qa'
  );
}

export const LOMA_URL_CLIENT = getLomaUrlClient();
export const RETURNS_GRAPHQL_URL = getReturnsGraphqlUrl();
export const RETURN_SERVICES_URL = getReturnServicesUrl();
export const NOFLAKE_URL = getNoflakeUrl();
export const APPS_GATEWAY_URL = getAppsGatewayUrl();
